import { render } from "./DbTableDeletePage.vue?vue&type=template&id=41a11ab9"
import script from "./DbTableDeletePage.vue?vue&type=script&lang=js"
export * from "./DbTableDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__